<template>
  <div class="mobile">
    <div class="mobileHeader">
      <img src="https://p0.ssl.qhimg.com/t11b673bcd64d75e3f41e19d2d5.png" alt="" class="mobileHeaderLogo" />
    </div>
    <img class="mobileBanner" src="https://p4.ssl.qhimg.com/t11b673bcd66af55da79a451e89.png" alt="" />
    <div class="mobileBrand">
      <div class="mobileBrandHead">
        <img
          src="https://p3.ssl.qhimg.com/t01e6cf92549ee92b7d.png"
          alt=""
          class="mobileBrandHeadLogo"
        />
        <div class="mobileBrandHeadText">{{ obj.brandChange?.title }}</div>
      </div>
      <div class="mobileBrandText mobileBrandTextOne">{{ obj.brandChange?.descOne }}</div>
      <div class="mobileBrandText mobileBrandTextTwo">{{ obj.brandChange?.descTwo }}</div>
      <div class="scrollable-div">
        <img src="https://p0.ssl.qhimg.com/t11b673bcd6104787796d9220da.png" alt="Sample Image" />
      </div>
      <div class="mobileBrandInfo">
        <div v-for="(item, index) in obj.brandChange?.details" class="mobileBrandInfoItem">
          <div class="mobileBrandInfoItemHead">
            <img
              class="mobileBrandInfoItemHeadIcon"
              src="https://p4.ssl.qhimg.com/t01d65004d0aff8c81f.png"
              alt=""
            />
            <span class="mobileBrandInfoItemHeadText">
              {{ item.name }}
            </span>
          </div>
          <div class="mobileBrandInfoItemBody">
            {{ item.info }}
          </div>
          <div class="mobileBrandInfoItemContent">{{ obj.brandChange?.titleOne }}</div>
        </div>
      </div>
    </div>
    <div class="mobileApp">
      <div class="mobileAppHead">
        <img
          src="https://p3.ssl.qhimg.com/t01e6cf92549ee92b7d.png"
          alt=""
          class="mobileBrandHeadLogo"
        />
        <div class="mobileBrandHeadText">{{ obj.aiApp?.title }}</div>
      </div>
      <div class="mobileAppDesc">{{ obj.aiApp?.desc }}</div>
      <div class="mobileAppSwipe">
        <van-swipe :height="340" class="my-swipe" :autoplay="3000" indicator-color="#1C1C1C">
          <van-swipe-item v-for="(item, index) in obj.aiApp?.children" :key="index">
            <div class="recruitBox">
              <img class="recruitBoxImg" :src="item.icon" alt="" />
              <div class="recruitBoxTitle">{{ item.name }}</div>
              <div class="recruitBoxInfo">{{ item.detail }}</div>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
      <img @click="openAppQues" src="https://p4.ssl.qhimg.com/t11b673bcd6b652f2e69284526c.png" class="mobileAppBtn" alt="" />
    </div>
    <div class="mobileSafe">
      <div class="mobileSafeHead">
        <img
          src="https://p3.ssl.qhimg.com/t01e6cf92549ee92b7d.png"
          alt=""
          class="mobileSafeHeadLogo"
        />
        <div class="mobileSafeHeadText">{{ obj.aiGlobal?.title }}</div>
      </div>
      <div class="mobileSafeDesc">
        <div class="mobileSafeDescText">
          {{ obj.aiGlobal?.desc }}
        </div>
      </div>
      <div v-for="(item, index) in obj.aiGlobal?.children" :key="index" class="mobileSafeInfo">
        <div class="mobileSafeInfoHead">
          <img
            src="https://p4.ssl.qhimg.com/t01d65004d0aff8c81f.png"
            alt=""
            class="mobileSafeInfoHeadIcon"
          />
          <span class="mobileSafeInfoHeadText">{{ item.name }}</span>
        </div>
        <div class="mobileSafeInfoBody">{{ item.detail }}</div>
      </div>
    </div>
    <div class="mobileProcess">
      <div class="mobileProcessItem">
        <div class="mobileProcessItemBox">
          <img :src="obj.aiGlobal?.iconArr[0].icon" alt="" class="mobileProcessItemBoxImg" />
        </div>
        <div class="mobileProcessItemText">{{ obj.aiGlobal?.iconArr[0].info }}</div>
      </div>
      <img class="arrow" src="https://p5.ssl.qhimg.com/t01f953bb4c13a4d4d4.png" alt="" />
      <div class="mobileProcessItem">
        <div class="mobileProcessItemBox">
          <img :src="obj.aiGlobal?.iconArr[1].icon" alt="" class="mobileProcessItemBoxImg" />
        </div>
        <div class="mobileProcessItemText">{{ obj.aiGlobal?.iconArr[1].info }}</div>
      </div>
      <img class="arrow" src="https://p5.ssl.qhimg.com/t01f953bb4c13a4d4d4.png" alt="" />
      <div class="mobileProcessItem">
        <div class="mobileProcessItemBox">
          <img :src="obj.aiGlobal?.iconArr[2].icon" alt="" class="mobileProcessItemBoxImg" />
        </div>
        <div class="mobileProcessItemText">{{ obj.aiGlobal?.iconArr[2].info }}</div>
      </div>
      <img class="arrow" src="https://p5.ssl.qhimg.com/t01f953bb4c13a4d4d4.png" alt="" />
      <div class="mobileProcessItem special">
        <div class="mobileProcessItemBox specialBox">
          <img :src="obj.aiGlobal?.iconArr[3].icon" alt="" class="mobileProcessItemBoxImg" />
        </div>
        <div class="mobileProcessItemText specialText">{{ obj.aiGlobal?.iconArr[3].info }}</div>
      </div>
      
    </div>
    <!-- <img @click="openSafeQues" :src="obj.aiGlobal?.btnImg" :class="{ fixed: isFixed }" class="mobileProcessBtn"> -->
    <img @click="openSafeQues" src="https://p4.ssl.qhimg.com/t11b673bcd6b652f2e69284526c.png" class="mobileProcessBtn">

  </div>
</template>

<script setup>
import { ref, onBeforeMount, onMounted } from 'vue'
import { getRecruit } from '@/api/2024/index'

// const obj = ref({
//   brandChange: {
//     title: '品牌蜕变',
//     descOne:
//       '当前，AI大模型应用浪潮奔涌，为拥抱AI高速发展带来的诸多巨变，第十二届互联网安全大会（以下简称“ISC.AI 2024”）全面启动，正式升级为ISC.AI2024，将于7月31日-8月1日在北京国家会议中心召开，开启“聚变元年”。',
//     descTwo:
//       '本届大会将深度聚焦AI与安全两大领域，打造集行业前瞻对话、高峰技术研讨、先进成果展示、创新孵化大赛、产业人才培训于一体的全球首个安全+AI“聚”会，探索“用AI做安全”和“让AI更安全”全球前沿命题，助力数字安全与AI领域的共融创生与跃迁升级，助推新质生产力发展。',
//     details: [
//       {
//         name: '双域扩维探索数智共荣',
//         info: '本届大会开创双域扩维新模式，一域将以“AI赋能数字安全”为出发点，共话AI时代下安全新发展，探索安全大模型在不同场景下的实战应用，及各类大模型安全问题新解法。一域以“AI赋能数转智改”为出发点，探索AI大模型在金融、能源、教育等行业的垂直解决方案，发掘办公、生活等多场景下的多模态应用。'
//       },
//       {
//         name: '产教赋能打破人才瓶颈',
//         info: '本届大会将联合ISC数字安全生态联盟、GPT产业联盟等合作伙伴，基于“AI+安全”两大赛道，分享技术应用，搭建特色展区，为安全及服务、AI大模型技术场景输送资源，助力挖掘出更多商业机会和发展空间；同时通过加强政府、企业、高等院校、科研院所等多方交流，大会将构建融合发展的产业生态体系。'
//       },
//       {
//         name: '生态聚力发掘行业增量',
//         info: '本届大会将以人才教培为核心，打造ISC学院训练营、ISC特色大讲堂、产教成果展等特色活动。将围绕AI大模型与数字安全输出专项培训课程，打造“讲、培、训、练”一体化正循环人才培养体系；更有知名企业家、高校名师现场直播公开课，高维战略、必修技术、创业成长等热门话题一网打尽。'
//       },
//       {
//         name: '数字体验推动AI创生',
//         info: '本届大会将打造数字安全生态展区、AI体验馆、AI生态展区、AI艺术展、赛博文化街等特色活动，并以领先的数智化能力重塑会前、会中、会后的全流程周期。通过不同场景的多触点布局，保障全域参会观众需求的精准触达，为千万级观众打造出数实场景深度融合、交互体验多维立体的沉浸式参会体验。'
//       }
//     ]
//   },
//   aiApp: {
//     title: 'AI应用招募',
//     desc: '为保证大会的含“AI”量，大会将致力推动人工智能从感知走向认知、从识别走向生成、从专用走向通用，展现当下大模型赋能各行各业的多元生态，让大众现场体会技术切实的魅力。',
//     children: [
//       {
//         icon: 'https://p4.ssl.qhimg.com/t01a68f7966ff16da14.png',
//         name: '数字人招募',
//         detail:
//           '大会将联合产业合作伙伴共建虚拟人生态平台，招募厂商将提供数字员工、数字主持人、数字客服等AI虚拟人应用，能够随时随地为观众提供展会问题解答、呈现观展指引等一站式智能服务。 '
//       },
//       {
//         icon: 'https://p1.ssl.qhimg.com/t01ee68c0aaa7ff1ca4.png',
//         name: '数字场景类招募',
//         detail:
//           '大会将基于数字场景类大模型技术构建聚拢行业厂商和创新产品的窗口，招募厂商将支持各类数字论坛、AI展厅&展会、数字应用体验品等特色活动的落地，打造冲击感官的沉浸式体验。'
//       },
//       {
//         icon: 'https://p2.ssl.qhimg.com/t0130f8326ceddd60dd.png',
//         name: 'AI工具类招募',
//         detail:
//           '大会将为观众提供各类AI工具，招募厂商将提供包括但不限于智能翻译，智能同传，大模型会议向导，会议内容总结等AI能力，助力提升本次大会的办会效率与观众的逛会体验。'
//       }
//     ],
//     btnImg: 'https://p4.ssl.qhimg.com/t11b673bcd6b652f2e69284526c.png'
//   },
//   aiGlobal: {
//     title: '全球AI+安全议题招募',
//     desc: 'ISC互联网安全大会是全球规格最高、规模最大、覆盖最广、影响力最深远的安全峰会之一，自2013年肇始迄今累计设立超600场分论坛，输出超4500个行业前沿议题，吸引来自全球30多个国家的2000余位政要、行业领袖、专家学者的深度参与，被誉为中国网络安全产业名片、全球网络安全行业风向标。为进一步推动AI大模型与数字安全的高质量发展，本届大会将面向全球展开议题征集。',
//     children: [
//       {
//         name: '数字安全议题征集',
//         detail:
//           '本次征集既关注了当下AI赋能数字安全发展的落地实践，也聚焦了AIGC人工智能、量子计算等新兴技术澎湃发展背后的前瞻安全问题，并同时兼顾了全球网络空间对抗下的实战攻防、威胁情报、漏洞挖掘等传统业务安全的关键能力，将以此激发出的AI+安全融合发展的思想大繁荣。'
//       },
//       {
//         name: 'AI大模型议题征集',
//         detail:
//           '本次AI大模型议题征集则聚焦AI大模型对于全行业发展的深远影响，既关注金融、能源、教育等核心关键行业的细分垂直应用，也致力探索多场景、多模态的全新解决方案，助力AI大模型技术与业务的融合发展。'
//       }
//     ],
//     iconArr: [
//       {
//         icon: 'https://p0.ssl.qhimg.com/t0153d38c840b0a2f4f.png',
//         info: '提交报名'
//       },
//       {
//         icon: 'https://p1.ssl.qhimg.com/t015c8402c2cd424e93.png',
//         info: '议题评审'
//       },
//       {
//         icon: 'https://p0.ssl.qhimg.com/t010930eb71776a4e9b.png',
//         info: '结果公示'
//       },
//       {
//         icon: 'https://p1.ssl.qhimg.com/t01d4366f7f36a61ae4.png',
//         info: 'ISC.AI 2024主题演讲'
//       }
//     ],
//     btnImg: 'https://p4.ssl.qhimg.com/t11b673bcd6b652f2e69284526c.png'
//   }
// })

const obj = ref({})
const isFixed = ref(false);

const handleScroll = () => {
  isFixed.value = window.scrollY > 0;
};

onMounted(() => {
  window.addEventListener('scroll', handleScroll);
});

onBeforeMount(async () => {
  await fetch()
})

function openAppQues() {
  const url = 'https://wenjuan.lap.360.cn/sv/j3ol4132asavh'; // 你想要打开的链接
  window.open(url, '_blank'); // _blank 指定在新窗口中打开链接
}

function openSafeQues() {
  const url = 'https://wenjuan.lap.360.cn/sv/qdq98kk6ey8zx'; // 你想要打开的链接
  window.open(url, '_blank'); // _blank 指定在新窗口中打开链接
}

function fetch() {
  getRecruit('SDRMejc5bUluN0h6NGV6Q0ZISEo4QT09Ojq0u0voSpe8Welb3YCLl3nS')
    .then((res) => {
      obj.value = JSON.parse(res.data.data.data)
    })
    .catch(() => {})
}
</script>

<style lang="scss" scoped>
.fixed {
  position: fixed;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
}
.mobile {
  width: 100%;
  &Header {
    height: 74px;
    display: flex;
    align-items: center;
    padding-left: 25px;
    border-bottom: 0.6px solid rgb(0, 0, 0);
    &Logo {
      width: 129px;
    }
  }
  &Banner {
    width: 100%;
    height: 360px;
  }
  &Brand {
    margin: 84px 0 0;
    padding-left: 24px;
    &Head {
      display: flex;
      margin-bottom: 36px;
      &Text {
        color: rgb(0, 0, 0);
        font-size: 28px;
        font-weight: 700;
        line-height: 28px;
        letter-spacing: 0px;
        text-align: left;
        margin-left: 20px;
      }
    }
    &Text {
      padding-right: 24px;
      text-align: justify;
      color: rgb(0, 0, 0);
      font-size: 14px;
      font-weight: 350;
      line-height: 24px;
      letter-spacing: 0px;
      text-align: justify;
      &One {
        margin-bottom: 14px;
      }
      &Two {
        margin-bottom: 58px;
      }
    }
    &Info {
      margin: 64px 0 38px;
      padding-right: 24px;
      &Item {
        margin-bottom: 24px;
        padding-bottom: 24px;
        border-bottom: 0.5px solid rgb(0, 0, 0);
        &Head {
          display: flex;
          align-items: center;
          margin-bottom: 16px;
          &Icon {
            width: 18px;
          }
          &Text {
            color: rgb(0, 0, 0);
            margin-left: 12px;
            font-size: 18px;
            font-weight: 500;
            line-height: 18px;
            height: 18px;
            letter-spacing: 0px;
            text-align: left;
          }
        }
        &Body {
          color: rgb(0, 0, 0);
          font-size: 14px;
          font-weight: 350;
          line-height: 28px;
          letter-spacing: 0px;
          text-align: justify;
        }
      }
    }
  }

  &App {
    background: rgb(246, 247, 253);
    padding: 57px 0 67px;
    &Head {
      padding: 0 24px;
      display: flex;
      margin-bottom: 36px;
      &Text {
        color: rgb(0, 0, 0);
        font-size: 28px;
        font-weight: 700;
        line-height: 28px;
        letter-spacing: 0px;
        text-align: left;
        margin-left: 20px;
      }
    }
    &Desc {
      padding: 0 24px;
      color: rgb(0, 0, 0);
      font-size: 14px;
      font-weight: 350;
      line-height: 28px;
      letter-spacing: 0px;
      text-align: justify;
      margin-bottom: 52px;
    }
    &Swipe {
      padding: 0 63px;
    }
    &Btn {
      width: 302px;
      height: 60px;
      margin: 64px auto 0;
      display: block;
    }
  }

  &Safe {
    padding: 74px 24px 0;
    &Head {
      display: flex;
      margin-bottom: 36px;
      &Text {
        color: rgb(0, 0, 0);
        font-size: 28px;
        font-weight: 700;
        line-height: 28px;
        letter-spacing: 0px;
        text-align: left;
        margin-left: 20px;
      }
    }
    &Desc {
      color: rgb(0, 0, 0);
      font-size: 14px;
      font-weight: 350;
      line-height: 28px;
      letter-spacing: 0px;
      text-align: justify;
      margin-bottom: 50px;
    }
    &Info {
      margin-bottom: 40px;
      &Head {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        &Text {
          color: rgb(0, 0, 0);
          font-size: 18px;
          font-weight: 500;
          line-height: 18px;
          letter-spacing: 0px;
          text-align: left;
        }
      }
      &Body {
        color: rgb(0, 0, 0);
        font-size: 14px;
        font-weight: 350;
        line-height: 28px;
        letter-spacing: 0px;
        text-align: justify;
      }
    }
  }

  &Process {
    padding: 15px 24px 0;
    display: flex;
    justify-content: space-between;
    position: relative;
    margin-bottom: 42px;
    // gap: 0 2px;
    &Item {
      width: 74px;
      &Box {
        width: 74px;
        height: 74px;
        border-radius: 50%;
        background: rgb(243, 246, 252);
        display: flex;
        justify-content: center;
        align-items: center;
      }
      &Text {
        margin-top: 23px;
        color: rgb(0, 0, 0);
        font-size: 14px;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: 0px;
        text-align: center;
      }
    }
    .arrow {
      margin-top: 35px;
      width: 12px;
      height: 9px;
    }
    .special {
      // width: 80px;
      &Text {
        width: 80px;
      }
    }
    &Btn {
      width: 302px;
      height: 60px;
      display: block;
      margin: 0 auto 55px;
    }
  }

  .scrollable-div {
    height: 528px;
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    cursor: grab;
    user-select: none; /* 禁止文本被选中 */
  }

  .scrollable-div:active {
    cursor: grabbing;
  }

  .scrollable-div img {
    height: 100%;
    display: block;
  }
  ::-webkit-scrollbar {
    width: 12px;
    height: 12px;
  }
  ::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 6px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
  .recruit {
    &Box {
      &Img {
        width: 62px;
        display: block;
        margin: 0 auto;
      }
      &Title {
        margin: 12px 0 20px;
        text-align: center;
        color: rgb(0, 0, 0);
        font-size: 18px;
        font-weight: 500;
        line-height: 18px;
        letter-spacing: 0px;
      }
      &Info {
        color: rgb(0, 0, 0);
        font-size: 14px;
        font-weight: 350;
        line-height: 28px;
        letter-spacing: 0px;
        text-align: justify;
      }
    }
  }
  :deep(.van-swipe__indicator) {
    width: 10px;
    height: 10px;
  }
  --van-swipe-indicator-inactive-background: #c4c4c4;
}
</style>
